"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = require('react');

var _ = require('lodash');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var numericInputHelper = require('../../util/numericInputHelpers');

var Toggle = require('../toggle');

var Corner = require('./corner/corner');

var LockedSymbol = require('../icons/link_light.svg.js');

var UnlockedSymbol = require('../icons/break_link_light.svg.js');

var CORNERS = {
  topLeft: 0,
  topRight: 1,
  bottomRight: 2,
  bottomLeft: 3
};

var getCornerIndex = function getCornerIndex(corner) {
  return CORNERS[corner];
};

var getValuesArray = function getValuesArray(value) {
  var valuesArrayNoUnits = value.replace(/px/g, '').split(' ').map(Number);
  return valuesArrayNoUnits.length === 1 ? _.fill(Array(4), valuesArrayNoUnits[0]) : valuesArrayNoUnits;
};

var CornerRadiusInput = /*#__PURE__*/function (_React$Component) {
  _inherits(CornerRadiusInput, _React$Component);

  var _super = _createSuper(CornerRadiusInput);

  function CornerRadiusInput(props) {
    var _this;

    _classCallCheck(this, CornerRadiusInput);

    _this = _super.call(this, props);
    _this.state = {
      locked: _this.props.isInitiallyLocked
    };

    _this.getClassName = function () {
      return "".concat(_this.props.getClassName('control-corner-radius-input'), " ").concat(_this.state.locked ? 'locked' : 'unlocked');
    };

    _this.handleLinkClick = function (value) {
      _this.setState({
        locked: value
      });
    };

    _this.getCornerValue = function (corner) {
      var values = getValuesArray(_this.props.value);
      return values[getCornerIndex(corner)];
    };

    _this.getValidValue = function (value, corner) {
      var prevValue = _this.getCornerValue(corner);

      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;
      return numericInputHelper.getValidNumericValue(value, prevValue, min, max);
    };

    _this.handleCornerChange = function (corner, e) {
      var newCornerValue = e.target.value;

      var diff = newCornerValue - _this.getCornerValue(corner);

      var newValue = _this.calcNewVal(diff, corner);

      _this.props.onChange(newValue);
    };

    _this.calcNewVal = function (diff, corner) {
      var value = _this.props.value;
      return _this.state.locked ? _this.calLockedVal(value, diff) : _this.calcUnlockedVal(value, diff, corner);
    };

    _this.calLockedVal = function (value, diff) {
      var cornerByIndex = _.invert(CORNERS);

      return getValuesArray(value).map(function (v, i) {
        var corner = cornerByIndex[i];
        return _this.getValidValue(_this.getCornerValue(corner) + diff, corner) + 'px';
      }).join(' ');
    };

    _this.calcUnlockedVal = function (value, diff, corner) {
      return _(value).thru(getValuesArray).assign(_defineProperty({}, getCornerIndex(corner), _this.getValidValue(_this.getCornerValue(corner) + diff, corner))).map(function (v) {
        return "".concat(v, "px");
      }).join(' ');
    };

    _this.onBlurTopLeft = _this.onBlurTopLeft.bind(_assertThisInitialized(_this));
    _this.onBlurTopRight = _this.onBlurTopRight.bind(_assertThisInitialized(_this));
    _this.onBlurBottomLeft = _this.onBlurBottomLeft.bind(_assertThisInitialized(_this));
    _this.onBlurBottomRight = _this.onBlurBottomRight.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CornerRadiusInput, [{
    key: "onBlurTopLeft",
    value: function onBlurTopLeft(e) {
      this.handleCornerChange('topLeft', e);
    }
  }, {
    key: "onBlurTopRight",
    value: function onBlurTopRight(e) {
      this.handleCornerChange('topRight', e);
    }
  }, {
    key: "onBlurBottomLeft",
    value: function onBlurBottomLeft(e) {
      this.handleCornerChange('bottomLeft', e);
    }
  }, {
    key: "onBlurBottomRight",
    value: function onBlurBottomRight(e) {
      this.handleCornerChange('bottomRight', e);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.getClassName()
      }, /*#__PURE__*/React.createElement("div", {
        className: "top"
      }, /*#__PURE__*/React.createElement(Corner, {
        onBlur: this.onBlurTopLeft,
        position: "top-left",
        min: this.props.min,
        max: this.props.max,
        value: this.getCornerValue('topLeft')
      }), /*#__PURE__*/React.createElement(Corner, {
        onBlur: this.onBlurTopRight,
        position: "top-right",
        min: this.props.min,
        max: this.props.max,
        value: this.getCornerValue('topRight')
      })), /*#__PURE__*/React.createElement(Toggle, {
        className: "link",
        value: this.state.locked,
        onChange: this.handleLinkClick
      }, this.state.locked ? /*#__PURE__*/React.createElement("span", {
        key: "lockedSymbol",
        className: "symbol lockedSymbol"
      }, /*#__PURE__*/React.createElement(LockedSymbol, null)) : null, this.state.locked ? null : /*#__PURE__*/React.createElement("span", {
        key: "unlockedSymbol",
        className: "symbol unlockedSymbol"
      }, /*#__PURE__*/React.createElement(UnlockedSymbol, null))), /*#__PURE__*/React.createElement("div", {
        className: "bottom"
      }, /*#__PURE__*/React.createElement(Corner, {
        onBlur: this.onBlurBottomLeft,
        position: "bottom-left",
        min: this.props.min,
        max: this.props.max,
        value: this.getCornerValue('bottomLeft')
      }), /*#__PURE__*/React.createElement(Corner, {
        onBlur: this.onBlurBottomRight,
        position: "bottom-right",
        min: this.props.min,
        max: this.props.max,
        value: this.getCornerValue('bottomRight')
      })));
    }
  }]);

  return CornerRadiusInput;
}(React.Component);

CornerRadiusInput.displayName = displayNames.CORNER_RADIUS_INPUT;
CornerRadiusInput.propTypes = {
  /** The corner radius value in px. Can be in the format of '6px' for all corners or splitted '1px 2px 2px 1px' */
  value: PropTypes.string.isRequired,

  /** a callback called with the new value when updating corner radius in the format of splitted corners, e.g. '1px 2px 2px 1px' */
  onChange: PropTypes.func.isRequired,

  /** is initiated with bounded values */
  isInitiallyLocked: PropTypes.bool,

  /** max corner radius input */
  max: PropTypes.number,

  /** min corner radius input */
  min: PropTypes.number
};
CornerRadiusInput.defaultProps = {
  isInitiallyLocked: true,
  max: 999,
  min: 0
};
module.exports = compose(CornerRadiusInput);